import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "dynamic",
    component: () => import("@/views/DynamicDetail.vue")
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
